<template>
    <div>
        <loading :active.sync="isLoading" background-color="#272727" :opacity="0.2"></loading> 
        <router-view v-if="isRouterAlive"></router-view>
    </div>
    
</template>

<script>
import Global from '@/models/UI/Global'

export default {
    name: 'Layout',
    provide() {    
        return {
            reload: this.reload      
        }
    },
    data() {
        return {
            isRouterAlive: true, 
            isLoading: false //讀取效果
        }
    },
    created() {
        this.load();
    },
    methods: {
        //首次載入讀取
        async load() {
            Global.$on('isLoading', (isLoading) => {
                this.isLoading = isLoading;
            });
        },
        //使用provide/inject方式，刷新頁面
        async reload () {
            this.isRouterAlive = false;
            this.$nextTick( ()=> { this.isRouterAlive=true } ) ;
        },
    },
    beforeDestroy() {
        // 元件銷毀前要註銷監聽事件    
        Global.$off('isLoading');
    }
}
</script>



// WEBPACK FOOTER //
// src/views/Layout.vue